import { render, staticRenderFns } from "./show_patent.vue?vue&type=template&id=914e32d0"
import script from "./show_patent.vue?vue&type=script&lang=js"
export * from "./show_patent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports